import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { getCourseById, editCourse } from "../../../../redux/educator/actions";
import { setInitialSteps } from "../../../../redux/shared/actions";
import { StateType } from "../../../../utils/types";
import {
  selectCourse,
  selectCoursesLoading,
  selectCourseSubmitLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  course: selectCourse(state),
  loading: selectCoursesLoading(state),
  submitLoading: selectCourseSubmitLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getCourseById,
      setInitialSteps,
      editCourse,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
